import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { UpgradePromptBannerProps } from './UpgradePromptBanner';

export function LazyUpgradePromptBanner(props: UpgradePromptBannerProps) {
  const UpgradePromptBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "upgrade-prompt-banner" */ './UpgradePromptBanner'
      ),
    {
      preload: false,
      namedImport: 'UpgradePromptBanner',
    },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-mocha',
          feature: 'Upgrade Prompts',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <UpgradePromptBanner {...props} />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
}
